import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import { useModel as _useModel, mergeModels as _mergeModels } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "role-swtich-content"
};
var _hoisted_2 = {
  class: "swtich-body"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "radio-label"
};
import { ref, toRefs, onMounted, watch } from 'vue';
import { MessagePlugin as message } from 'tdesign-vue-next';
import useUserStore from '@/stores/modules/user';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import { changeUserType } from '@/api/user.js';
export default {
  __name: 'RoleSwitchDialog',
  props: {
    "visible": false,
    "visibleModifiers": {}
  },
  emits: /*@__PURE__*/_mergeModels(['refresh'], ["update:visible"]),
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var router = useRouter();
    var userStore = useUserStore();
    var _storeToRefs = storeToRefs(userStore),
      userInfo = _storeToRefs.userInfo,
      currentRole = _storeToRefs.currentRole;
    console.log(router);
    var manager = require('@/assets/home/manager.png');
    var teacher = require('@/assets/home/teacher.png');
    var student = require('@/assets/home/student.png');
    var roleData = [{
      name: '教师',
      icon: teacher,
      type: 'teacher'
    }, {
      name: '管理员',
      icon: manager,
      type: 'manager'
    }, {
      name: '学生',
      icon: student,
      type: 'student'
    }];
    var emit = __emit;
    var visible = _useModel(__props, 'visible', false);
    var activeCourrent = ref(currentRole.value);
    var roleList = ref([]);
    watch(function () {
      return visible.value;
    }, function (val) {
      activeCourrent.value = currentRole.value;
      roleList.value = val ? roleData.filter(function (item) {
        var _userInfo$value$membe;
        return (_userInfo$value$membe = userInfo.value.memberType) === null || _userInfo$value$membe === void 0 ? void 0 : _userInfo$value$membe.includes(item.type);
      }) : [];
    }, {
      immediate: true,
      deep: true
    });
    /**
     * 切换角色
     */
    var redirectConfig = {
      manager: '/admin',
      teacher: '/home',
      student: '/student'
    };
    var handleSure = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var params, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {
                userId: userInfo.value.id,
                type: activeCourrent.value
              };
              _context.n = 1;
              return changeUserType(params);
            case 1:
              _context.n = 2;
              return userStore.setCurrentRole(activeCourrent.value);
            case 2:
              _context.n = 3;
              return router.replace({
                path: redirectConfig[activeCourrent.value]
              });
            case 3:
              visible.value = false;
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              message.error((_t === null || _t === void 0 ? void 0 : _t.massage) || '身份切换失败');
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[0, 4]]);
      }));
      return function handleSure() {
        return _ref2.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      var _component_t_radio = _resolveComponent("t-radio");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        visible: visible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return visible.value = $event;
        }),
        destroyOnClose: "",
        "close-on-overlay-click": false,
        header: "请选择你的身份",
        width: "450",
        class: "role-swtich-dialog",
        onConfirm: handleSure
      }, {
        body: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("p", {
            class: "title"
          }, "切换身份类型的同时工作台将发生变化", -1)), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleList.value, function (item) {
            return _openBlock(), _createElementBlock("div", {
              key: item.type,
              class: "swtich-item",
              onClick: function onClick($event) {
                return activeCourrent.value = item.type;
              }
            }, [_createElementVNode("img", {
              src: item.icon,
              alt: ""
            }, null, 8, _hoisted_4), _createVNode(_component_t_radio, {
              value: item.type,
              checked: item.type === activeCourrent.value
            }, {
              label: _withCtx(function () {
                return [_createElementVNode("span", _hoisted_5, _toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["value", "checked"])], 8, _hoisted_3);
          }), 128))])])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
};